import type { Look } from '../../types/Color'

const CM_PER_INCH = 2.54
const INCHES_PER_FOOT = 12

interface ModelHeightProps {
	selectedLook: Look
	sizeInInches: boolean
}

export const getModelHeight = ({
	selectedLook,
	sizeInInches,
}: ModelHeightProps): string | undefined => {
	const { modelHeight } = selectedLook

	if (!modelHeight) {
		return
	}
	if (sizeInInches) {
		const inchesTotal = Number(modelHeight) / CM_PER_INCH
		const feet = Math.floor(inchesTotal / INCHES_PER_FOOT)
		const inches = Math.round(inchesTotal % INCHES_PER_FOOT)
		return `${feet}'${inches}"`
	}
	return `${modelHeight}cm`
}
